import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedstate  from 'vuex-persistedstate'
import user from './module/user'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user
  },
  plugins:[
    createPersistedstate({
      key:'qdzyyx_store',// 存数据的key名   自定义的  要有语义化
    }) 
  ]
})
